<template>
  <div
    class="scroll-mt-15"
    style="
      background:
        url('/images/bg-right-pattern.svg') right no-repeat,
        linear-gradient(184deg, #fbf5e7 1.28%, #fff 94.01%);
      background-size: auto, auto;
      overflow: hidden;
      background-position: top right;
    "
  >
    <LayoutsContainer>
      <ArticlesHubHero :heading="heading">
        <div v-if="articles.length" class="relative max-w-md">
          <Icon
            name="icon:search"
            class="text-brand-500 pointer-events-none absolute top-1/2 left-4 h-5 w-5 -translate-y-1/2"
          />
          <input
            v-model="searchTerm"
            :placeholder="`Search articles`"
            class="border-accent-500 focus:ring-accent-500 w-full rounded-lg border-1 bg-white py-3 pr-4 pl-12 text-black focus:ring-2 focus:outline-none"
          />
        </div>
      </ArticlesHubHero>
      <BaseDivider class="max-md:mt-6 max-md:mb-10 md:my-16" />
      <div v-if="articles.length > 0" class="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        <ArticlesHubCard v-for="article in articles" :key="article.id" :article="article" />
      </div>
      <div v-else>
        <p>No articles found.</p>
      </div>
    </LayoutsContainer>
  </div>
</template>

<script setup lang="ts">
const { params } = useRoute();
console.log(params);
const { data, pending, error } = await useAsyncData(`articles-category-${params.category}`, async (nuxtApp) => {
  console.log(`/api/articles/category-hub/?term=${params.category}`);
  const response = await $fetch(`/api/articles/category-hub/?term=${params.category}`);
  return response;
});

if (!data.value && import.meta.server) {
  setResponseStatus(404, 'Page not found');
} else if (data.value) {
  useBellevueSEO((data.value as any).seo);
}

const searchTerm = ref<string>('');
const heading = computed(() => {
  return data.value?.heading || 'not found.';
});
const articles = computed(() => {
  if (data.value) {
    return (data.value as any).posts.filter((v: { title: string }) =>
      v.title.toLowerCase().includes(searchTerm.value.toLowerCase()),
    );
  }

  return [];
});
console.log(data.value);
</script>
